"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.currentClientUUID = exports.createUniformSetting = void 0;
var lodash_1 = __importDefault(require("lodash"));
var locale_1 = require("./locale/locale");
var global_config_1 = require("./utils/global_config");
var env_1 = require("./env");
Object.defineProperty(exports, "currentClientUUID", { enumerable: true, get: function () { return env_1.currentClientUUID; } });
var environment_1 = require("./utils/environment");
function createUniformSetting(config) {
    var verbose = config.verbose, loggedIn = config.loggedIn, baseAccountUrl = config.baseAccountUrl, axiosInstance = config.axiosInstance, region = config.region;
    var verboseNormal = verbose || environment_1.IS_DEBUG;
    var gConfig = new global_config_1.GlobalConfig({
        region: region
    });
    var locale = new locale_1.Locale(gConfig, lodash_1.default.extend({
        verbose: verboseNormal,
        loggedIn: loggedIn,
        baseAccountUrl: baseAccountUrl,
        axiosInstance: axiosInstance,
    }, config === null || config === void 0 ? void 0 : config.locale));
    var env = new env_1.Env(gConfig);
    return {
        locale: locale,
        env: env,
    };
}
exports.createUniformSetting = createUniformSetting;
//# sourceMappingURL=library.js.map